import { Loader, useReport, ExportCsvButton } from "../shared";

export const DailyComparisonSection = ({ filter }) => {
  const [data, loading] = useReport("/reports/daily-comparison", filter, true);
  if (loading) return <Loader />;
  if (!data) return null;
  const rows = [
    { metric: "Sales",      current: data.today.sales,        yest: data.yesterday.sales,        lw: data.last_week_same_day.sales,        avg: data.trailing_7day_avg.sales,        prefix: "$" },
    { metric: "Tips",       current: data.today.tips,         yest: data.yesterday.tips,         lw: data.last_week_same_day.tips,         avg: data.trailing_7day_avg.tips,         prefix: "$" },
    { metric: "Orders",     current: data.today.orders,       yest: data.yesterday.orders,       lw: data.last_week_same_day.orders,       avg: data.trailing_7day_avg.orders,       prefix: ""  },
    { metric: "Avg Ticket", current: data.today.avg_ticket,   yest: data.yesterday.avg_ticket,   lw: data.last_week_same_day.avg_ticket,   avg: data.trailing_7day_avg.avg_ticket,   prefix: "$" },
  ];
  const fmt = (v, p) => `${p}${Number(v).toFixed(p === "$" ? 2 : 0)}`;
  const delta = (curr, base) => {
    if (!base) return null;
    const pct = ((curr - base) / base) * 100;
    return { sign: pct >= 0 ? "▲" : "▼", text: `${Math.abs(pct).toFixed(1)}%`, good: pct >= 0 };
  };
  return (
    <div className="overflow-x-auto" data-testid="comparison-section">
      <div className="flex justify-end mb-2">
        <ExportCsvButton path="/reports/daily-comparison/export.csv" filter={filter} isSingleDay testId="export-comparison-csv" />
      </div>
      <table className="w-full text-sm">
        <thead className="text-xs uppercase text-muted-foreground">
          <tr className="border-b border-border">
            <th className="text-left py-2">Metric</th>
            <th className="text-right py-2">Today</th>
            <th className="text-right py-2">Yesterday</th>
            <th className="text-right py-2">Last Week</th>
            <th className="text-right py-2">7-Day Avg</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => {
            const dy = delta(r.current, r.yest);
            const dlw = delta(r.current, r.lw);
            const da = delta(r.current, r.avg);
            return (
              <tr
                key={r.metric}
                className="border-b border-border/50"
                data-testid={`compare-row-${r.metric.toLowerCase()}`}
              >
                <td className="py-2 font-medium">{r.metric}</td>
                <td className="py-2 text-right font-mono font-semibold">
                  {fmt(r.current, r.prefix)}
                </td>
                <td className="py-2 text-right font-mono">
                  {fmt(r.yest, r.prefix)}{" "}
                  {dy && (
                    <span className={`text-xs ${dy.good ? "text-green-600" : "text-red-600"}`}>
                      {dy.sign}{dy.text}
                    </span>
                  )}
                </td>
                <td className="py-2 text-right font-mono">
                  {fmt(r.lw, r.prefix)}{" "}
                  {dlw && (
                    <span className={`text-xs ${dlw.good ? "text-green-600" : "text-red-600"}`}>
                      {dlw.sign}{dlw.text}
                    </span>
                  )}
                </td>
                <td className="py-2 text-right font-mono">
                  {fmt(r.avg, r.prefix)}{" "}
                  {da && (
                    <span className={`text-xs ${da.good ? "text-green-600" : "text-red-600"}`}>
                      {da.sign}{da.text}
                    </span>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
